import { Tab } from "@headlessui/react";
import { Fragment } from "react";
import { useMemo, useEffect } from "react";
import InvoiceLayout from "../invoice-master/invoice-layout.component";
import InvoiceEntry from "./invoice-entry.component";
import InvoiceApproval from "../invoice-master/invoice-approval.component";
// import EInvoiceList from "src/features/fields/pages/E-Invoices/E-InvoiceList";
import { useParams } from "react-router-dom";
import EInvoiceList from "src/features/fields/pages/E-Invoices/E-InvoiceList";
import usePermission from "src/hooks/usePermission";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import { toast } from "src/hooks/useToast";
import TextractEntry from "./textract-entry.component";

const InvoiceHomepage = () => {
  const { tabIndex } = useParams();

  const { hasPermission: viewInvoiceEntryApprovalPermission, loading: isViewInvoicePermissionLoading } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE.ENTRY.module,
    action: fineGrainedPermissionsKeys.INVOICE.ENTRY.action,
  });

  const { hasPermission: viewEInvPermission, loading: isViewEInvPermissionLoading } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE.ENTRY.module,
    action: fineGrainedPermissionsKeys.INVOICE.ENTRY.action,
  });

  const isPermissionsLoading = isViewInvoicePermissionLoading || isViewEInvPermissionLoading;

  let tabs = [
    {
      title: "Entry",
      condition: !isViewInvoicePermissionLoading && viewInvoiceEntryApprovalPermission,
      component: <InvoiceEntry />,
    },
    {
      title: "Approval",
      condition: !isViewInvoicePermissionLoading && viewInvoiceEntryApprovalPermission,
      component: <InvoiceApproval />,
    },
    {
      title: "Unverified E-Invoices",
      condition: !isViewEInvPermissionLoading && viewEInvPermission,
      component: <EInvoiceList checkDataType={true} status={"Unverified"} />,
    },
     {
      title: "MV Lens", //change name
      condition: !isViewInvoicePermissionLoading && viewInvoiceEntryApprovalPermission,
      component: <TextractEntry />,
    },
  ];

  const filteredTabs = useMemo(() => {
    return (tabs || []).filter((tab) => tab.condition !== false);
  }, [tabs, isPermissionsLoading]);

  useEffect(() => {
    if (!isViewInvoicePermissionLoading && viewInvoiceEntryApprovalPermission === false) {
      toast({
        variant: "destructive",
        description: "You don't have permission to view Entry and Approval Invoices",
      });
    }
  }, [isViewInvoicePermissionLoading, viewInvoiceEntryApprovalPermission]);

  return (
    <InvoiceLayout>
      <header className="flex flex-col justify-between py-5 mx-auto max-h-[100vh]">
        <div className="flex justify-between px-[3.75rem]">
          <div className="">
            <h1 className="text-[#49484C] font-bold text-[2rem]">Invoices</h1>
          </div>
        </div>

        {!isPermissionsLoading && (
          <Tab.Group defaultIndex={Number(tabIndex) ?? 0}>
            <Tab.List className="relative px-[3.75rem] mb-[1.16rem] mt-2 border-b-[1px] border-b-[#E9E9E9] shadow-md">
              {filteredTabs.map((item: any) => (
                <Tab key={item.title} as={Fragment}>
                  {({ selected }: { selected: boolean }) => (
                    <div
                      className={`relative inline-block cursor-pointer -bottom-[1px] px-4 py-3 font-semibold text-sm  border-b-2  not-italic  hover:border-b-[#586AF5] hover:text-[#586af5] focus:outline-none ${
                        selected ? "text-[#586af5] border-b-[#586AF5]" : "text-[rgba(0,0,0,0.4)] border-b-transparent"
                      }`}
                    >
                      {item.title}
                    </div>
                  )}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels>
              {filteredTabs.map((item: any) => (
                <Tab.Panel className="px-[3.75rem]" key={item.title}>
                  {item.component}
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>
        )}
      </header>
    </InvoiceLayout>
  );
};

export default InvoiceHomepage;
